// @flow
import types from "./types";
import type {TokenData} from "./reducers";

const updateRequestData = (tokenData: TokenData) => ({
    type: types.TOKEN_DATA_UPDATE,
    payload: tokenData,
});

const failTokenDecrypt = (errorMessage: string) => ({
    type: types.TOKEN_DATA_ERROR,
    payload: errorMessage
});

export default {
    updateRequestData,
    failTokenDecrypt,
};



// WEBPACK FOOTER //
// ./src/Store/Ducks/TokenData/actions.js